module.exports = __webpack_public_path__ + "static/media/Collection_4.3bed588a.jpg";